/**
 * 日期格式化工具函数
 * 
 * @author AI Assistant
 * @created 2025-12-02
 */

/**
 * 格式化日期时间
 * 
 * @param dateString ISO 8601 日期字符串
 * @param format 格式化模板 (默认: 'YYYY-MM-DD HH:mm:ss')
 * @returns 格式化后的日期字符串
 */
export const formatDate = (
  dateString: string,
  format: string = 'YYYY-MM-DD HH:mm:ss'
): string => {
  if (!dateString) return '-'

  const date = new Date(dateString)

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateString)
    return '-'
  }

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return format
    .replace('YYYY', String(year))
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

/**
 * 格式化相对时间 (例如: "3 分钟前", "2 小时前")
 * 
 * @param dateString ISO 8601 日期字符串
 * @returns 相对时间字符串
 */
export const formatRelativeTime = (dateString: string): string => {
  if (!dateString) return '-'

  const date = new Date(dateString)

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateString)
    return '-'
  }

  const now = new Date()
  const diff = now.getTime() - date.getTime()

  const seconds = Math.floor(diff / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (days > 7) {
    return formatDate(dateString, 'YYYY-MM-DD')
  } else if (days > 0) {
    return `${days} 天前`
  } else if (hours > 0) {
    return `${hours} 小时前`
  } else if (minutes > 0) {
    return `${minutes} 分钟前`
  } else {
    return '刚刚'
  }
}
